<template>
  <v-chip
    :color="getStatusColor(status.name)"
    text-color="white"
    class="text-uppercase"
    label
  >
    {{ status.localizedText }}
  </v-chip>
</template>

<script>
export default {
  name: 'Status',
  props: {
    status: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getStatusColor(status) {
      let color = 'default';

      switch (status) {
        case 'NEW':
          color = '#2281C9';
          break;

        case 'PROCESSING':
          color = '#CC9C00';
          break;

        case 'REJECTED':
          color = '#831919';
          break;

        case 'SOLVED':
          color = '#6EB300';
          break;

        case 'SOLVED_WITH_EXCEPTION':
          color = '#54883A';
          break;

        default:
          color = 'default';
      }

      return color;
    },
  },
};
</script>
